// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"131ea2ba","453":"df96b018","553":"e9aeb922","611":"93bc2795","636":"841a6780","734":"40181bf5","743":"e0bf37d0","777":"412b3fd0","801":"9f07102f","841":"cf212292","852":"6cae3c51","898":"dc6222fc","977":"e6f6a900"}[chunkId] + ".chunk.js";
};